import * as React from 'react';

import Responsive from 'common/components/Responsive';
import { handlePromise, onReject } from 'common/utils/Bugsnag';
import ColorComponent from 'projects/components/Color';
import DateRange from 'projects/components/DateRange';
import FadeIn from 'projects/components/FadeIn';
import {
    ObservableField as Field,
    ObservableForm,
    Observe,
} from 'projects/components/ObservableForm';
import Timeframe, { TimeframeValue } from 'projects/components/TimeFrame';
import { Color } from 'projects/consts';

export interface Fields {
    timeframe: TimeframeValue;
    startDate: any | null;
    endDate: any | null;
}

interface Props<T> {
    form: ObservableForm<T>;
}

export default function TimeframeField<T extends Fields>(props: Props<T>) {
    const { form } = props;

    const timeframe = (): TimeframeValue => form.get('timeframe');

    const DateSelector = () => {
        const dateField = (
            <Field
                form={form}
                name={['startDate', 'endDate']}
                title={__('Choose a start & end date')}
                render={() => (
                    <>
                        <Responsive min="normal">
                            <DateRange
                                startDate={form.get('startDate')}
                                endDate={form.get('endDate')}
                                onChange={(name, value) => {
                                    handlePromise(form.set(name, value), 'TimeAndBudgetPage');
                                }}
                                orientation="horizontal"
                            />
                        </Responsive>
                        <Responsive max="medium">
                            <DateRange
                                startDate={form.get('startDate')}
                                endDate={form.get('endDate')}
                                onChange={(name, value) => {
                                    handlePromise(form.set(name, value), 'TimeAndBudgetPage');
                                }}
                                orientation="vertical"
                            />
                        </Responsive>
                    </>
                )}
            />
        );
        return (
            <FadeIn wrapperComponent="div" wrapperClassName="wrapped-card">
                {timeframe() == 'SPECIFIC_DATES' && dateField}
            </FadeIn>
        );
    };

    return (
        <>
            <Field
                form={form}
                name="timeframe"
                title={__("What's your timeline?")}
                message={__(
                    'Your designer will confirm whether your delivery date can be met based on project scope and their availability.'
                )}
                render={() => (
                    <ColorComponent color={Color.createBlue}>
                        <Timeframe
                            value={timeframe()}
                            onChange={async value => {
                                try {
                                    await form.set('timeframe', value);
                                } catch {
                                    onReject('TimeAndBudgetPage');
                                } finally {
                                    if (value === 'SPECIFIC_DATES') {
                                        form.scrollTo('startDate');
                                    }
                                }
                            }}
                        />
                    </ColorComponent>
                )}
            />

            <Observe form={form} name="timeframe" render={() => <DateSelector />} />
        </>
    );
}
